module.exports = __webpack_public_path__ + "img/1561427195.e6770403.jpg";